export default __webpack_public_path__ + "static/media/logo.64358e90.png";